<h2 mat-dialog-title>
  Change Key
  <span [style.color]="'var(--sys-primary)'">{{ data.name }}</span> Expiration
</h2>
<mat-dialog-content>
  <div class="rh-dateTime-container">
    <mat-form-field>
      <mat-label>Select a date</mat-label>
      <input matInput [matDatepicker]="picker" [formControl]="date">
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <ngx-mat-timepicker-field color="primary" [format]="12" [defaultTime]="time.value ?? '12:12 PM'"
      (timeChanged)="time.patchValue($event)"></ngx-mat-timepicker-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="onNoClick()" [style.background]="'var(--sys-secondary)'"
    [style.color]="'var(--sys-on-secondary)'">Cancel</button>
  <button mat-button [mat-dialog-close]="{id: data.id, expires_at: dateTime.value}"
    [style.background]="'var(--sys-primary)'" [style.color]="'var(--sys-on-primary)'" cdkFocusInitial>Confirm</button>
</mat-dialog-actions>